var DropdownUtility = (function () {
    const DROPDOWN_CLASS = "select_custom";

    function _addDropdown($element) {
        if (!$element.hasClass("transformed")) {
            $element.addClass("transformed");

            var $select = $element;
            var numberOfOptions = $element.children("option").length;

            var maxQty = $element.data('maxQty');
            if (typeof maxQty !== "undefined" && maxQty !== 'none') {
                numberOfOptions = maxQty;
            }

            var isDisabled = $element.prop("disabled"); // Check if the original select is disabled
            const isReadOnly = $element.hasClass("readOnly"); // Check if the original select is readonly
            $select.prop('required',false);

            if (isDisabled) {
                $select.prop('disabled', true); // Set the disabled attribute if original select is disabled
            }

            if ($select.parents('.select').length === 0) {
                $select.wrap('<div class="select"></div>');
            }

            var $styled = $('<div class="select-styled"></div>');
            var $search = $('<input class="search-select" name="search-select">');
            var $searchIcon = $('<i class="search-icon fas fa-search"></i>');

            if ($select.hasClass('hidden')) {
                $styled.addClass('hidden');
            }

            var $icon = $(
                `<div class="filter-icon ${$select.attr("name")}"></div>`
            );

            if (!$select.data("show-search-in-list")) {
                $select.after($search);
            }
            $select.after($styled);

            var $styledSelect = $select.next("div.select-styled");

            if (isDisabled || isReadOnly) {
                $styledSelect.addClass("disabled"); // Add a class to indicate that the custom dropdown is disabled
            }

            $styledSelect.text($select.data("title"));

            if (
                $("option:selected", $select).length &&
                $("option:selected", $select).val()
            ) {
                $styledSelect.text($("option:selected", $select).text());
            }

            // Only prepend icon IF the select box has a class of select_icon
            if ($select.hasClass('select_icon')){
                $styledSelect.prepend($icon);
            }

            $styledSelect.append($('<div class="arrow"></div>'));

            var $list = $("<ul />", {
                class: "select-options",
            }).insertAfter($styledSelect);

            if ($select.data("show-search-in-list")) {
                // show search box in the list
                var $searchContainer = $("<li />", {
                    class: "select-custom-search-container",
                }).appendTo($list);
                $searchContainer.append($searchIcon);
                $search.appendTo($searchContainer);

                // prevent list from closing when search input is clicked
                $search.on('mousedown', function(e) {
                    e.stopPropagation();
                });
            }

            function clearSearchText() {
                $("li.select-custom-option", $list).removeClass('hidden');
                $search.val('');
            }

            let myTimeout;

            $search.on('keyup', function (e) {
                let val = $(this).val().toLocaleLowerCase();
                let time = 3000;
                $("li.select-custom-option", $list).addClass('hidden');
                $("li.select-custom-option", $list).filter(function () {
                    return $(this).text().toLocaleLowerCase().indexOf(val) >= 0;
                }).removeClass('hidden');

                if (!$select.data("show-search-in-list")) {
                    if ($("li.select-custom-option", $list).length === $("li.hidden", $list).length) {
                        $("li.select-custom-option", $list).removeClass('hidden');
                        time = 1500;
                    }

                    window.clearTimeout(myTimeout);
                    myTimeout = window.setTimeout(clearSearchText, time);
                }
            });

            var children = $select.children("option");

            if ($select.data("sort")) {
                children.sort(function (a, b) {
                    var aVal = a.value;
                    var bVal = b.value;
                    if (/\d/.test(aVal)) {
                        aVal = aVal.match(/\d+/);
                        bVal = bVal.match(/\d+/);

                        return $select.data("sort") === "ascending"
                            ? aVal - bVal
                            : bVal - aVal;
                    }

                    if ($select.data("sort") === "ascending") {
                        return a.value.localeCompare(b.value);
                    } else {
                        return b.value.localeCompare(a.value);
                    }
                });
            }

            // Add the hidden clear button
            if ($select.hasClass("addclear")) {
                var show = children.length === 2;
                var clearClass = show ? "" : " hide";
                $(
                    "<li class='clear select-custom-option" + clearClass + "'>-- Clear --</li>"
                ).appendTo($list);
            }

            // Add select element options into list for custom dropdown
            for (var i = 0; i < numberOfOptions; i++) {
                if ($(children.eq(i)).val()) {
                    // do not include hidden select elements
                    var classes = $(children.eq(i)).attr("class");
                    if (classes) {
                        classes = classes.split(/\s+/);
                    } else {
                        classes = "";
                    }
                    $("<li />", {
                        text: children.eq(i).text(),
                        rel: children.eq(i).val(),
                        class: classes + " select-custom-option",
                    }).appendTo($list);
                }
            }

            var $listItems = $list.children("li.select-custom-option");

            $styledSelect.mousedown(function (e) {
                e.stopPropagation();

                if (!$select.prop("disabled") && !$select.hasClass("readOnly")) {
                    $target = $(e.target);
                    var parent = $target.closest(".select-styled");
                    var isOpen = parent.hasClass("active");
                    $(".select-styled").removeClass("active");
                    var visibleMultiSelects = $(".multi-select").filter(function() {
                        return $(this).hasClass("active");
                    });
                    visibleMultiSelects.removeClass("active");
                    visibleMultiSelects.trigger("closed");

                    if (!isOpen) {
                        parent.addClass("active");
                    }

                    $(parent).parent('.select').find('.search-select').trigger('focus');
                }
            });


            $listItems.on('mousedown update', function (e, d) {
                e.stopPropagation();
                if ($(this).hasClass("clear")) {
                    $styledSelect.text($select.data("title"));
                    $select.val([]);
                    if (! d?.suppressChangeEvent) {
                        $select.change();
                    }
                    $list.children(".clear").addClass("hide");

                    var name = $(this)
                        .parents(".select")
                        .children("select")
                        .attr("name");
                    $(".selected button").each(function () {
                        if (
                            $(this).data("key") !== "" &&
                            $(this).data("key") === name
                        ) {
                            $(this).trigger('mousedown');
                        }
                    });
                } else {
                    if ($list.children("li.select-custom-option").length > 1) {
                        $list.children(".clear").removeClass("hide");
                    }
                    $select.val($(this).attr("rel"));
                    if (! d?.suppressChangeEvent) {
                        $select.change();
                    }
                    $styledSelect.text($(this).text());
                }

                // Only prepend icon IF the select box has a class of select_icon
                if ($select.hasClass('select_icon')){
                    $styledSelect.prepend($icon);
                }
                $styledSelect.append($('<div class="arrow"></div>'));
                $styledSelect.removeClass("active");

                // clear search
                clearSearchText();
            });

            $(document).on('mousedown', function () {
                $styledSelect.removeClass("active");
            });
        }
    }

    function load() {

        $("select." + DROPDOWN_CLASS).each(function () {
            _addDropdown($(this));
        });

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                $(mutation.addedNodes).each(function () {
                    if ($(this).prop("type") == "select-one") {
                        if ($(this).hasClass(DROPDOWN_CLASS)) {
                            _addDropdown($(this));
                        }
                    }
                    $(this)
                        .find("select." + DROPDOWN_CLASS)
                        .each(function () {
                            _addDropdown($(this));
                        });
                });
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    }

    return {
        load: load,
    };
})();

$(function () {
    DropdownUtility.load();
});

$.fn.redrawSelect = function () {
    this.next('.select-styled').remove();
    let $select = this.clone().removeClass('transformed').removeClass('hidden');
    let parent = this.parent('.select');
    parent.empty().append($select);
    return this;
};

$.fn.hideSelect = function () {
    this.addClass('hidden').next('.select-styled').addClass('hidden');
    this.parent('.select').prev('label').addClass('hidden');
    return this;
};

$.fn.showSelect = function () {
    this.removeClass('hidden').next('.select-styled').removeClass('hidden');
    this.parent('.select').prev('label').removeClass('hidden');
    return this;
};

$.fn.updateVal = function (val, suppressChangeEvent = false) {
    this.val(val);
    let value = val.toString().replace(/(['"])/g, "\\$1");
    this.siblings(".select-options").find("li[rel='" + value + "']").trigger('update', { suppressChangeEvent });
    return this;
};

$.fn.setDisplayText = function (text) {
    this.next('.select-styled')
        .text(text)
        .append($('<div class="arrow"></div>'));
    return this;
};

$.fn.setDisabled = function (disabled) {
    if (disabled) {
        this.prop('disabled', true);
        this.next('.select-styled').addClass('disabled');
    } else {
        this.prop("disabled", false);
        this.next('.select-styled').removeClass('disabled');
    }
    return this;
};
